import React from 'react';
import { AutReportDetail } from './AutReportDetail';
import { BendReportDetail } from './BendReportDetail';
import { ChemicalReportDetail } from './ChemicalReportDetail';
import { CoatingReportDetail } from './CoatingReportDetail';
import { CvnReportDetail } from './CvnReportDetail';
import { DimensionalReportDetail } from './DimensionalReportDetail';
import { FlatteningReportDetail } from './FlatteningReportDetail';
import { HardnessReportDetail } from './HardnessReportDetail';
import { HeatTreatReportDetail } from './HeatTreatReportDetail';
import { HydrostaticReportDetail } from './HydrostaticReportDetail';
import { MflEtReportDetail } from './MflEtReportDetail';
import { MptReportDetail } from './MptReportDetail';
import { PipeBodyUtReportDetail } from './PipeBodyUtReportDetail';
import { RtReportDetail } from './RtReportDetail';
import { StandardReportDetail } from './StandardReportDetail';
import { TensileReportDetail } from './TensileReportDetail';
import { ThreadReportDetail } from './ThreadReportDetail';
import { VisualReportDetail } from './VisualReportDetail';
import { WeldMapReportDetail } from './WeldMapReportDetail';
import { STANDARD_REPORT_DETAILS } from './shared/sampleData';
import type { FullReportType, ProjectLimitFieldOption, ReportMeasurementItem, ReportMetadataEntry } from './shared/types';

export type ReportDetailRouterProps = {
  reportType: FullReportType;
  heatNumber: string;
  pipeLengthM?: number;
  metadata?: ReportMetadataEntry;
  frequency?: string;
  projectLimitFields?: ProjectLimitFieldOption[];
  measurements: ReportMeasurementItem[];
  deletedMeasurementIds: string[];
  onAddMeasurement: (reportType: FullReportType) => void;
  onEditMeasurement: (measurement: ReportMeasurementItem) => void;
  onDeleteMeasurement: (measurement: ReportMeasurementItem) => void;
  workflowPanel?: React.ReactElement | null;
};

export const ReportDetailRouter = ({
  reportType,
  heatNumber,
  pipeLengthM,
  metadata,
  frequency,
  projectLimitFields,
  measurements,
  deletedMeasurementIds,
  onAddMeasurement,
  onEditMeasurement,
  onDeleteMeasurement,
  workflowPanel,
}: ReportDetailRouterProps) => {
  const commonProps = {
    heatNumber,
    metadata,
    projectLimitFields,
    frequency,
    measurements,
    deletedMeasurementIds,
    onAddMeasurement,
    onEditMeasurement,
    onDeleteMeasurement,
  };

  if (reportType === 'CHEMICAL') return <ChemicalReportDetail {...commonProps} />;
  if (reportType === 'TENSILE') return <TensileReportDetail {...commonProps} pipeLengthM={pipeLengthM} />;
  if (reportType === 'CVN') return <CvnReportDetail {...commonProps} pipeLengthM={pipeLengthM} />;
  if (reportType === 'BEND') return <BendReportDetail {...commonProps} />;
  if (reportType === 'HARDNESS') return <HardnessReportDetail {...commonProps} />;
  if (reportType === 'AUT') return <AutReportDetail {...commonProps} pipeLengthM={pipeLengthM} />;
  if (reportType === 'DIMENSIONAL') return <DimensionalReportDetail {...commonProps} pipeLengthM={pipeLengthM} />;
  if (reportType === 'VISUAL') return <VisualReportDetail {...commonProps} pipeLengthM={pipeLengthM} />;
  if (reportType === 'RT') return <RtReportDetail {...commonProps} pipeLengthM={pipeLengthM} />;
  if (reportType === 'MPT') return <MptReportDetail {...commonProps} />;
  if (reportType === 'HEAT_TREAT') return <HeatTreatReportDetail {...commonProps} />;
  if (reportType === 'PIPE_BODY_UT') return <PipeBodyUtReportDetail {...commonProps} pipeLengthM={pipeLengthM} />;
  if (reportType === 'MFL_ET') return <MflEtReportDetail {...commonProps} />;
  if (reportType === 'COATING') return <CoatingReportDetail {...commonProps} />;
  if (reportType === 'THREAD') return <ThreadReportDetail {...commonProps} />;
  if (reportType === 'WELD_MAP') return <WeldMapReportDetail {...commonProps} />;
  if (reportType === 'FLATTENING') return <FlatteningReportDetail {...commonProps} />;
  if (reportType === 'HYDROSTATIC') return <HydrostaticReportDetail {...commonProps} />;

  if (STANDARD_REPORT_DETAILS[reportType]) {
    return (
      <>
        <StandardReportDetail reportType={reportType} heatNumber={heatNumber} />
        {workflowPanel}
      </>
    );
  }

  return workflowPanel ?? null;
};

export const ReportDetail = ReportDetailRouter;
